import { getProjectByDate } from '@/api/projects';
import { CalendarProps } from '@/interfaces/calendar_type';
import { getDaysInMonth, subMonths, addMonths, format } from 'date-fns';
import { useState, useEffect } from 'react';
import { OrangeButton, RouteButton } from '../../Buttons';
import { FullCalendar } from "./FullCalendar";


export function MonthlyCalendar() {
    const [currentMonth, setCurrentMonth] = useState(new Date());

    const [projectsDueThisMonth, setProjectsDueThisMonth] = useState<CalendarProps[]>([]);
    const daysInMonth = getDaysInMonth(currentMonth);

    //*** Handles month navigation
    const handlePrevMonth = () => {
        setCurrentMonth(subMonths(currentMonth, 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(addMonths(currentMonth, 1));
    };

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await getProjectByDate(currentMonth.getFullYear().toString(), (currentMonth.getMonth() + 1).toString(), "");

                // If a month only has one project, it will be returned as an object, so we need to convert it to an array
                const response_array = Array.isArray(response) ? response : [response];

                if (!response) {
                    throw new Error("Error fetching project list");
                }

                setProjectsDueThisMonth(Array.from({ length: daysInMonth }, (_, index) => {
                    const projects_due = response_array.filter(
                        (project) => {
                            const query = format(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), index + 1), "yyyy-MM-dd");
                            const end_date = project.end_date;
                            return end_date === query;
                        }
                    );

                    return {
                        day: index,
                        projects: projects_due
                    };
                }));

            } catch (error) {
                console.error("Server Error: ", error);
            }
        };
        fetchProjects();

    }, [currentMonth, daysInMonth]);

    //max-w-md my-5 mx-auto bg-slate-200 rounded-lg shadow-md p-6
    return (
        <>
            <div className='flex justify-center gap-4'>
                <OrangeButton onClick={() => setCurrentMonth(new Date())} className='p-4 transition '>
                    Go to Today
                </OrangeButton>

                <RouteButton route="/calendar/weekly" text="Switch to Weekly Calendar" />
            </div>

            <FullCalendar currentMonth={currentMonth} handlePrevMonth={handlePrevMonth} handleNextMonth={handleNextMonth} daysInMonth={daysInMonth} projectsDueToday={projectsDueThisMonth} />
        </>
    );
}
